import { useSelector } from 'react-redux';
import { U } from 'ts-toolbelt';

import { secondaryBundleNameSelector } from '../stateSelector';

const useSecondaryBundleName = (): U.Nullable<string> =>
  useSelector(secondaryBundleNameSelector);

export default useSecondaryBundleName;
